import { render, staticRenderFns } from "./UsersViewCompetition.vue?vue&type=template&id=5308a9a0"
import script from "./UsersViewCompetition.vue?vue&type=script&lang=js"
export * from "./UsersViewCompetition.vue?vue&type=script&lang=js"
import style0 from "./UsersViewCompetition.vue?vue&type=style&index=0&id=5308a9a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports